"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerTransport = void 0;
let TransportNodeU2FPromise;
const getTransportNodeU2F = async () => {
    if (TransportNodeU2FPromise === undefined) {
        TransportNodeU2FPromise = Promise.resolve().then(() => __importStar(require('@ledgerhq/hw-transport-u2f')));
    }
    return TransportNodeU2FPromise;
};
exports.LedgerTransport = {
    type: 'ledger',
    byteLimit: 256,
    load: async () => {
        const TransportNodeU2F = await getTransportNodeU2F();
        return {
            open: TransportNodeU2F.default.open,
            list: TransportNodeU2F.default.list,
            isSupported: TransportNodeU2F.default.isSupported,
        };
    },
};

//# sourceMappingURL=LedgerTransport.js.map
